import React from "react";

const MaintenancePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="max-w-lg w-full bg-white rounded-3xl border border-slate-100 shadow-sm p-10 text-center">
        <div className="w-16 h-16 mx-auto mb-6 rounded-2xl bg-amber-50 text-amber-600 flex items-center justify-center text-2xl font-black">
          !
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-3">Maintenance In Progress</h1>
        <p className="text-slate-500 text-sm leading-relaxed">
          The platform is temporarily unavailable while we perform scheduled maintenance.
          Please check back shortly.
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;
